import React from 'react';
import store, { searchActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import RecycleBinTable from './tables/RecycleBinTable';
import debounce from 'lodash.debounce';
import { BfiCustomStore } from '../common/SharedComponents';
import RestoreLoanModal from './modals/RestoreLoanModal';
import LoanSummaryModal from './modals/LoanSummaryModal';
import EditStdLoanModal from './modals/EditStdLoanModal';
import EditMasterNoteModal from './modals/EditMasterNoteModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const RecycleBinLandingPage = () => {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;

    const debouncedSearch = debounce(dispatch, 500);
    const gridStore = new BfiCustomStore();

    const _onSearchChange = (event) => {
        debouncedSearch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    loanRecycleBin: event.target.value,
                },
            })
        );
    };

    return (
        <>
            <div
                className='page-header'
                role='banner'
            >
                <h1>Loans - Recycle Bin</h1>
                <div className='primary-actions'>&nbsp;</div>
            </div>
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div className='input-has-icon main-search'>
                    <input
                        type='search'
                        placeholder='Search on BFI Number, loan number, city, state, borrower or user...'
                        defaultValue={searchState?.searchText?.loanRecycleBin}
                        onChange={_onSearchChange}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden='true'
                        className='icon'
                    />
                </div>
                <div
                    className='scrollable-content'
                    style={{ padding: '1rem' }}
                >
                    <RecycleBinTable gridStore={gridStore} />
                </div>
            </div>
            <RestoreLoanModal />
            <LoanSummaryModal />
            <EditStdLoanModal />
            <EditMasterNoteModal />
        </>
    );
};

export default RecycleBinLandingPage;
